import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white py-14 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between gap-8">
        {/* Logo Section */}
        <div className="flex flex-col">
          <h1 className="bri text-5xl font-bold">Zittle</h1>
        </div>

        {/* Menu Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Documents</h3>
          <ul className="space-y-2">
            <li>
              <a href="/terms-conditions" className="hover:underline">
                Terms And Conditions
              </a>
            </li>
            <li>
              <a href="/privacy-policy" className="hover:underline">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/refund-cancellation-policy" className="hover:underline">
                Refund And Cancellation Policy
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Us Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
          <ul className="space-y-2 max-w-96">
            <li className="flex items-center gap-2">
              <span>📍</span> Zittle Technologies Private Limited, 37-1, Raja Street, Bhavani Show Room,
              Gudur, Nellore District, Andhra Pradesh - 524101
            </li>
            <li className="flex items-center gap-2">
              <a href="mailto:support@zittle.in">
                <span>📧</span> support@zittle.in
              </a>
            </li>
            <li className="flex items-center gap-2">
              <a href="tel:+917093303858">
                <span>📞</span> +91-7093303858
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
